import styled from '@emotion/styled';
import { TableCellShared } from './TableCellShared';
import { Text9 } from '../../../components/typography/Text9';
import { replaceAll } from '../../../utils/utils';

interface Props {
  text: string;
  isLastItem: boolean;
  url: string | null;
  category: string;
}

const TableCell = ({ category, isLastItem, text, url, ...props }: Props) => {
  return (
    <TableCellShared category={category} isLastItem={isLastItem} {...props}>
      {url ? (
        <Link href={url} target="_open">
          <BlueText>{text}</BlueText>
        </Link>
      ) : (
        <Text>{category === 'trialPhases' ? replaceAll(text, 'Phase ', '') : text}</Text>
      )}
    </TableCellShared>
  );
};

export default TableCell;

const Text = styled(Text9)`
  word-wrap: anywhere;
  flex-wrap: wrap;
`;
const BlueText = styled(Text)`
  color: #3053fc;
  text-decoration: underline;
`;

const Link = styled.a`
  cursor: pointer;
  text-decoration: none;
`;
